import React from "react";

import { Grid, Typography, makeStyles, Box } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

const useStyles = makeStyles(() => {
  return {
    mainContainer: {
      margin: "0.5rem 0",
    },

    fieldContainer: {
      display: "flex",
      alignItems: "center",
      gap: "0.25rem",
    },
  };
});

function SMSReportToggle(props) {
  const {
    value,
    handleToggle,
    error,
    name,
    label,
    disabled,
    toggleOptions = [],
    labelWidth,
    buttonStyles,
  } = props;

  const classes = useStyles({ labelWidth });

  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.fieldContainer}>
        {labelWidth !== "0%" ? (
          <Box style={{ width: labelWidth || "30%" }}>
            <Typography variant="body2" color={error ? "error" : "textPrimary"}>
              {label}
            </Typography>
          </Box>
        ) : null}
        <Box border={error ? "1px solid red" : ""}>
          <ToggleButtonGroup
            name={name}
            value={value}
            onChange={(e, value) => {
              if (handleToggle && typeof handleToggle === "function") {
                handleToggle(value);
              }
            }}
            exclusive>
            {toggleOptions?.map((toggleOption) => {
              return (
                <ToggleButton
                  style={{
                    textTransform: "none",
                    pointerEvents: disabled ? "none" : "",
                    ...buttonStyles,
                    ...(toggleOption?.style || {}),
                  }}
                  value={toggleOption?.value}>
                  {toggleOption?.label}
                </ToggleButton>
              );
            })}
          </ToggleButtonGroup>
        </Box>
      </Box>
      {error ? (
        <Typography variant="body2" style={{ fontSize: "12px" }} color="error">
          * Please select{" "}
          {typeof label === "string" ? label?.toLowerCase() : "any option"}
        </Typography>
      ) : null}
    </Box>
  );
}

export default SMSReportToggle;
